import { render, staticRenderFns } from "./infoMgr.vue?vue&type=template&id=512ed4b0&scoped=true"
import script from "./infoMgr.vue?vue&type=script&lang=js"
export * from "./infoMgr.vue?vue&type=script&lang=js"
import style0 from "./infoMgr.vue?vue&type=style&index=0&id=512ed4b0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512ed4b0",
  null
  
)

export default component.exports